import React, { Component } from 'react'

class SvgFile extends Component {
  render() {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="10"
        height="8"
        viewBox="0 0 10 8"
      >
        <path
          fill="#163878"
          fillRule="evenodd"
          d="M9.247 4.814L6.258 7.663a1.25 1.25 0 0 1-1.708 0 1.114 1.114 0 0 1 0-1.628l.945-.9H1.199C.537 5.135 0 4.623 0 3.99c0-.632.537-1.144 1.2-1.144h4.276l-.926-.882a1.113 1.113 0 0 1 0-1.628 1.249 1.249 0 0 1 1.708 0l2.989 2.849c.47.45.47 1.179 0 1.628z"
        />
      </svg>
    )
  }
}

export default SvgFile
